var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTokenEthWithBorder = function SvgTokenEthWithBorder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 28,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#D5D9F7",
    strokeWidth: 0.5,
    d: "M14.5.25C22.095.25 28.25 6.407 28.25 14c0 7.595-6.155 13.75-13.75 13.75C6.907 27.75.75 21.594.75 14 .75 6.407 6.907.25 14.5.25Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#8992B1",
    fillRule: "evenodd",
    d: "M14.613 3.951 7.645 14.207l6.968-2.695z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#656790",
    fillRule: "evenodd",
    d: "m7.645 14.207-.004.006 1.423.682 5.55 2.66v-6.043z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#666690",
    fillRule: "evenodd",
    d: "M14.613 3.951v7.56l.085-.031 6.846 2.672z",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#474876",
    fillRule: "evenodd",
    d: "m21.586 14.214-3.119 1.494-3.854 1.847v-6.042l.086-.034 6.845 2.673z",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#8A91B6",
    fillRule: "evenodd",
    d: "M14.613 23.672V18.51l-2.925-1.387-4.387-2.285z",
    clipRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#61688A",
    fillRule: "evenodd",
    d: "m17.538 17.123-2.925 1.386v5.163l7.312-8.833v-.001z",
    clipRule: "evenodd"
  })));
};
export { SvgTokenEthWithBorder as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjkiIGhlaWdodD0iMjgiIHZpZXdCb3g9IjAgMCAyOSAyOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE0LjUgMC4yNUMyMi4wOTQ2IDAuMjUwMDAxIDI4LjI1IDYuNDA2NjIgMjguMjUgMTRDMjguMjUgMjEuNTk0NiAyMi4wOTQ2IDI3Ljc1IDE0LjUgMjcuNzVDNi45MDY2MyAyNy43NSAwLjc1MDAwMSAyMS41OTQgMC43NSAxNEMwLjc1IDYuNDA2NjMgNi45MDY2MyAwLjI1IDE0LjUgMC4yNVoiIGZpbGw9IndoaXRlIiBzdHJva2U9IiNENUQ5RjciIHN0cm9rZS13aWR0aD0iMC41Ii8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTQuNjEzMiAzLjk1MTQyTDcuNjQ0NTMgMTQuMjA2NkwxNC42MTMyIDExLjUxMTlWMy45NTE0MloiIGZpbGw9IiM4OTkyQjEiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik03LjY0NTEyIDE0LjIwN0w3LjY0MDYyIDE0LjIxMzRMOS4wNjM1MiAxNC44OTUxTDE0LjYxMzggMTcuNTU1MlYxMS41MTI0TDcuNjQ1MTIgMTQuMjA3WiIgZmlsbD0iIzY1Njc5MCIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTE0LjYxMzMgMy45NTE0MlYxMS41MTE5TDE0LjY5NzkgMTEuNDc5OEwyMS41NDQyIDE0LjE1MTlMMTQuNjEzMyAzLjk1MTQyWiIgZmlsbD0iIzY2NjY5MCIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTIxLjU4NTYgMTQuMjEzNUwxOC40NjcxIDE1LjcwNzlMMTQuNjEzMyAxNy41NTUyVjExLjUxMjVMMTQuNjk4OCAxMS40Nzk1TDIxLjU0NDIgMTQuMTUyNEwyMS41ODU2IDE0LjIxMzVaIiBmaWxsPSIjNDc0ODc2Ii8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTQuNjEzMyAyMy42NzE4VjE4LjUxMDFMMTEuNjg4MyAxNy4xMjI2TDcuMzAwNzggMTQuODM4TDE0LjYxMzMgMjMuNjcxOFoiIGZpbGw9IiM4QTkxQjYiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNy41MzgzIDE3LjEyMjdMMTQuNjEzMyAxOC41MDk0VjIzLjY3MTlMMjEuOTI0OSAxNC44Mzg4VjE0LjgzOEwxNy41MzgzIDE3LjEyMjdaIiBmaWxsPSIjNjE2ODhBIi8+Cjwvc3ZnPgo=";